import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";
import aiPlan from "../../../assets/images/DietPlans/diet-plan-feature/caloriePlan.svg";
import report from "../../../assets/images/DietPlans/diet-plan-feature/report.png";
import Curated from "../../../assets/images/DietPlans/Curated.png";
import AIAccordianClosePlan from "../../../assets/images/DietPlans/AIAccordianPlan.png";
import guardians from "../../../assets/images/DietPlans/diet-plan-feature/guardians.png";
import waterTracker from "../../../assets/images/DietPlans/diet-plan-feature/waterTracker.png";
import estimatedHba1C from "../../../assets/images/DietPlans/diet-plan-feature/estimatedHba1C.png";
import checkRight from "../../../assets/images/DietPlans/check-mark-black.svg";
import { PlanName } from "../../../constants";

const featurePoint = [
  {
    icon: aiPlan,
    title: "Calorie tracking",
    description: "Count every calorie—stay on track, no excuses!",
  },
  {
    icon: report,
    title: "Report Insights",
    description:
      "Unlock powerful insights—see your progress, own your success!",
  },
  {
    icon: guardians,
    title: "Health guardians",
    description: "Your health, your rules—stay guided, stay unbeatable! ",
  },
  {
    icon: waterTracker,
    title: "Water tracker",
    description: "Hydrate like a pro—track it, sip it, crush it!",
  },
  {
    icon: estimatedHba1C,
    title: "Estimated Hba1C",
    description: "Know your numbers—take charge, stay ahead of diabetes!",
  },
];

const dietPlanAI = [
  {
    id: 1,
    label: "Curated Diet Plan",
    planImage: Curated,
    subList: [
      { id: 1, name: "Designed by Expert Nutritionists" },
      { id: 2, name: "Based on your health goals" },
      { id: 3, name: "Curated by experts" },
    ],
  },
];
const dietPlanSheet = [
  {
    id: 2,
    label: "Generated AI Diet plans",
    planImage: AIAccordianClosePlan,
    subList: [
      { id: 1, name: "Designed by our Proprietary AI" },
      { id: 2, name: "Based on your health data on Dr Trust app" },
      { id: 3, name: "Based on your dietary preferences" },
      { id: 4, name: "Based on your health goals" },
      { id: 5, name: "Food items popular in your region" },
      { id: 6, name: "Unique plan tailored to your exact needs" },
    ],
  },
];

const Feature = ({ selectedPlanType }) => {
  const [open, setOpen] = useState("1");
  const planFeatureRef = useRef(null);

  const plan =
    selectedPlanType === "one_month_ai_diet_plan_autopay_subscription"
      ? dietPlanSheet
      : dietPlanAI;

  const toggle = (id) => {
    setOpen((prevOpen) => (prevOpen === id ? null : id));
  };

  useEffect(() => {
    const handleScroll = () => {
      const planFeatureTop = planFeatureRef.current?.getBoundingClientRect().top;
      if (planFeatureTop > 0) {
        setOpen("1");
      } else {
        setOpen(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (

    <div className="feature-main mb-3 py-4 px-2">
      {(selectedPlanType !== PlanName.ELITE_PLAN && selectedPlanType !== PlanName.YEARLY_ELITE_PLAN) && <div className="accordion-container" ref={planFeatureRef}>
      {selectedPlanType
        ? plan?.map((v) => (
            <Accordion open={open} toggle={toggle} key={v?.id} >
              <AccordionItem>
                <div className="d-flex">
                  <div className="plan-image">
                    <img
                      className=""
                      src={v?.planImage}
                      alt="star"
                      loading="lazy"
                      height="100%"
                      width="100%"
                    />
                  </div>

                  <div style={{ flexGrow: 1 }}>
                    {selectedPlanType ===
                    "one_month_ai_diet_plan_autopay_subscription" ? (
                      <span className="diet-plan-offer-badge">NEW</span>
                    ) : null}
                    <AccordionHeader targetId="1">
                      <div>
                        <div className="accordion-heading">{v?.label}</div>
                        {open === null && (
                          <div className="subPlan">
                            {v?.subList?.[0]?.name}
                          </div>
                        )}
                      </div>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                      <ul style={{ listStyleType: "none", padding: 0 }}>
                        {v?.subList.map((list) => (
                          <li key={list?.id}>
                            <span className="checkmark">
                              <img width={8} src={checkRight} />
                            </span>{" "}
                            {list?.name}
                          </li>
                        ))}
                      </ul>
                    </AccordionBody>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>
          ))
        : null}
    </div>}
    
    {featurePoint.map((obj, i) => (
      <div key={i} className="plan-feature d-flex mb-4 align-items-start">
        <img src={obj.icon} alt="" loading="lazy" />
        <div>
          <h2>{obj.title}</h2>
          <p>{obj.description}</p>
        </div>
      </div>
    ))}
  </div>
  );
};

export default Feature;
